import { render, staticRenderFns } from "./ProductDetails.vue?vue&type=template&id=72303061&"
import script from "./ProductDetails.vue?vue&type=script&lang=js&"
export * from "./ProductDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports